import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import {
    Avatar,
    CardHeader,
    Dialog,
    DialogContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        "&:hover": {
            opacity: 0.8,
        },
    },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
    const classes = useStyles();
    const [imageModalOpen, setImageModalOpen] = useState(false);

    const handleImageClick = (e) => {
        e.stopPropagation();
        if (contact && contact.urlPicture) {
            setImageModalOpen(true);
        }
    };

    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    return (
        <React.Fragment>
            <CardHeader
                onClick={onClick}
                style={{ cursor: "pointer" }}
                titleTypographyProps={{ noWrap: true }}
                subheaderTypographyProps={{ noWrap: true }}
                avatar={
                    <Avatar
                        src={contact && contact.urlPicture}
                        alt="contact_image"
                        className={classes.clickableAvatar}
                        onClick={handleImageClick}
                    />
                }
                title={`${(contact && contact.name) || '(sem contato)'} #${ticket && ticket.id}`}
                subheader={[
                    ticket && ticket.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`,
                    contact && contact.contactWallets && contact.contactWallets.length > 0
                        ? `• ${i18n.t("wallets.wallet")}: ${(contact.contactWallets[0].wallet && contact.contactWallets[0].wallet.name) || 'N/A'}`
                        : null
                ].filter(Boolean).join(' ')}
            />

            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img
                        src={contact && contact.urlPicture}
                        alt={(contact && contact.name) || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;
